(function () {
  'use strict';

  function initPartnerPage(root) {
    if (!root || root.dataset.fgb2bInitialized === 'true') return;
    root.dataset.fgb2bInitialized = 'true';

    var formSection = root.querySelector('[data-fgb2b-form]');
    var interestSelect = root.querySelector('[data-fgb2b-interest-select]');

    root.querySelectorAll('[data-fgb2b-interest]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (!formSection) return;
        event.preventDefault();

        var interest = link.getAttribute('data-fgb2b-interest');
        if (interestSelect && interest) {
          Array.prototype.some.call(interestSelect.options, function (option) {
            if (option.value === interest || option.text === interest) {
              interestSelect.value = option.value;
              interestSelect.dispatchEvent(new Event('change', { bubbles: true }));
              return true;
            }
            return false;
          });
        }

        formSection.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });

        window.setTimeout(function () {
          if (interestSelect) interestSelect.focus({ preventScroll: true });
        }, 450);
      });
    });
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-fgb2b]')) initPartnerPage(context);
    context.querySelectorAll('[data-fgb2b]').forEach(initPartnerPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
